module.exports = __webpack_public_path__ + "static/img/banner1-vector.2e993cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg/banner1-vector.svg
// module id = ntpQ
// module chunks = 1 2